import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './i18n.resources';

export const internalInstance = createInstance();

internalInstance.use(initReactI18next).init({
  ns: ['shortlists', 'productions'],
  resources,
  lng: 'en',
  fallbackLng: 'en'
});
